export const href = "#javascipt"

//  Default page
export const Wellcome = "Wellcome Back, John!!"
export const WelcometothevihoFamily = "Welcome to the viho Family! we are glad that you are visite this dashboard. we will be happy to help you grow your business."
export const Update = "Update"
export const YearlyUser = "Yearly User"
export const Useractivations = "User Activations"
export const SuceessfullTransaction = "Suceessfull Transaction"
export const TotalBalance = "Total Balance"
export const Salesoverview = "Sales overview"
export const Morethanlastyear = "More than last year"
export const RecentOrders = "Recent Orders"
export const Done="Done"
export const Transactions = "Transaction"
export const Latestactivity = "Latest activity"
export const Today = "Today"
export const Month = "Month"
export const GrowthOverview = "Growth Overview"
export const Growths = "Growth"


// Ecommerce page
export const InvoiceOverview = "Invoice Overview"
export const InvoiceLegal = `<strong>Thank you for your business!</strong>  Payment is expected within 31 days; please process this invoice within that time. There will be a 5% interest charge per month on late invoices.`
export const TopDealer = "Top Dealer"
export const ViewMore ="View More"
export const Yearlygrowth = "Yearly growth"
export const ActivityTimeline = "Activity Timeline"
export const UpdatedProduct = "Updated Product"
export const UpdatedProducts ="Quisque a consequat ante Sit amet magna at volutapt."
export const New = "new"
export const News = "New"
export const Likeyourproduct ="Vestibulum nec mi suscipit, dapibus purus ane."
export const Tomorrow= "Tomorrow"
export const Colors= "Colors"
export const TodayTotalRevenue = "Today Total Revenue"
export const TotalSellings = "Total Selling"
export const TopSellingProduct = "Top Selling Product"

// General page
export const kolkata = "kolkata"
export const India = "India"
export const Surat ="Surat"
export const Sale = "Sale"
export const RECENTACTIVITY = "RECENT ACTIVITY"
export const PRODUCTSCART = "PRODUCTS CART"
export const EMPLOYEESTATUS = "EMPLOYEE STATUS"
export const ContactUs = "Contact Us"
export const Email = "Email"
export const Message = "Message"
export const YourMessage = "Your Message"
export const SENDIT ="SEND IT"

// chart page
export const SALE =  "SALE"
export const PROJECTS = "PROJECTS"
export const PRODUCTS = "PRODUCTS"
export const MarketingExpenses = "Marketing Expenses"
export const TotalEarning = "Total Earning"
export const LiveProduct = "Live Products"
export const Turnovers = "Turnover"
export const MonthlySale = "Monthly Sales"
export const Uses = "Uses"
export const BrowserUses = "Browser Uses"


// page layout
export const BoxLayout = "Box Layout"
export const Home = "Home"
export const PageLayout = "Page Layout"
export const Title = "Title"
export const LayoutDark = "Layout Dark"
export const ColorVersion = "Color Version"
export const FooterDark = "Footer Dark"
export const Footers= "Footers"
export const FooterFixed = "Footer Fixed"
export const FooterLight = "Footer Light"
export const RTLLayout  ="RTL Layout"
export const Step = "Step"
export const CardFooter = "Card Footer"
export const SampleCard = "Sample Card"
export const SampleCardBody = "lorem ipsum dolor sit amet, consectetur adipisicing elit"

// state color page
export const DefaultColor ="Default Color"
export const StateColor = "State Color"
export const Base = "Base"


// Typography page
export const Typography = "Typography"
export const Headings = "Headings"
export const HeadingsMessage = `All HTML headings, <code>&lt;h1&gt;</code> through
<code>&lt;h6&gt;</code>, are available.`
export const HeadingsExample = "This is a Heading"
export const Heading = "Heading"
export const SubHeading = "Sub Heading"
export const Displayheadings = "Display headings"
export const Display = "Display"
export const Lead = "Lead"
export const Inlinetextelements ="Inline text elements"
export const TextColor = "Text Color"
export const ListingTypography = "Listing Typography"
export const Blockquotes = "Blockquotes"
export const FancyFontMessage = `Fancy display heading<small class="text-muted">With faded secondary text</small>`
export const DisplayheadingsMessage=`Traditional heading elements are designed to work best in the
meat of your page content. When you need a heading to stand out,consider using a <strong>display heading</strong>—a larger, slightly more opinionated heading style.`
export const LeadMessage=`Make a paragraph stand out by adding <code>.lead</code>.`
export const  LeadContent="Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus."
export const Unorderlist= "Unorder list"
export const Orderlist= "Order list"
export const Fontawesomelist= "Fontawesome list"
export const ICOIconlist= "ICO Icon list"
export const Themfylist= "Themfy list"
export const BlockquotesMessage = `Add a <code>&lt;footer class="blockquote-footer"&gt;</code> for identifying the source. Wrap the name of the source work in <code>&lt;cite&gt;</code>.`
export const searchMessage = "Opps!! There are no result found."

// Avatars page
export const Avatars ="Avatars"
export const Sizing ="Sizing"
export const SatusIndicators ="Satus Indicators"
export const Initials ="Initials"
export const Shape ="Shape"
export const Groups = "Groups"

// Grid page
export const Grid= "Grid"
export const GridOptions = "Grid Options"
export const GridOptionsMessage = `While Bootstrap uses <code>em </code>or <code>rem </code>for
defining most sizes, <code>px</code> are used for grid
breakpoints and container widths. This is because the viewport
width is in pixels and does not change with the
<a {href}>font size</a>.`
export const GridOptionstitle = "Bootstrap grid allows building an equal height flexbile blocks easily"
export const GridColumn ="Grid Column"
export const GridColumnMessage = `Using a single set of <code>.col-md-*</code> grid classes, you can create a basic grid system that starts out stacked on mobile devices and tablet devices (the extra small to small range) before becoming horizontal on desktop (medium) devices. Place grid columns within any <code>.row</code>.`
export const oneColumnwidth = "Setting one column width"
export const oneColumnwidthMessage = `Auto-layout for flexbox grid columns also means you can set the width of one column and have the sibling columns automatically resize around it. You may use predefined grid classes (as shown below), grid mixins, or inline widths. Note that the other columns will resize no matter the width of the center column.`
export const Verticalalignment = "Vertical alignment"
export const VerticalalignmentMessage="Use flexbox alignment utilities to vertically and horizontally align columns."
export const Oneofthreecolumns = "One of three columns"
export const Horizontalalignment = "Horizontal alignment"
export const Oneoftwocolumns ="One of two columns"
export const NestingColumn = "Nesting Column"
export const Order= "Order"
export const OrderMessage=`Use <code>.order-</code> classes for controlling the <strong>visual order</strong> of your content. These classes are responsive, so you can set the <code>order</code> by breakpoint (e.g., <code>.order-1.order-md-2</code>). Includes support for <code>1</code> through <code>12</code> across all five grid tiers.`
export const Offsetheader ="Offset"
export const OffsetheaderMessage=`Move columns to the right using <code>.offset-md-*</code> classes. These classes increase the left margin of a column by <code>*</code> columns. For example, <code>.offset-md-4</code> moves <code>.col-md-4</code> over four columns.`
export const Extrasmall ="Extra small"
export const Small ="Small"
export const Medium= "Medium"
export const Large= "Large"
export const Extralarge= "Extra large"
export const Gridbehavior ="Grid behavior"
export const Horizontalatalltimes= "Horizontal at all times"

// Tag & Pills page
export const TagPills = "Tag & Pills"
export const Contextualvariation = "Contextual variations"
export const Primary="Primary"
export const Secondary ="Secondary"
export const Success = "Success"
export const Info = "Info"
export const Warning= "Warning"
export const Danger = "Danger"
export const Light ="Light"
export const Dark="Dark"
export const Tagswithnumber = "Tags with number"
export const Tagswithicon = "Tags with icon"
export const Pillswithnumber = "Pills with number"
export const PillswithIcon= "Pills with Icon"
export const BadgeExample= "Badge Example"
export const Badgesaspartbuttons= "Badges as part buttons"
export const Messages= "Messages"

// helperclasses page
export const HelperClasses = "Helper Classes"
export const Padding = "Padding"
export const Margins = "Margins"
export const PaddingLeft = "Padding Left"
export const PaddingRight = "Padding Right"
export const PaddingTop = "Padding Top"
export const PaddingBottom = "Padding Bottom"
export const MarginLeft ="Margin Left"
export const MarginRight ="Margin Right"
export const MarginTop ="Margin Top"
export const MarginBottom= "Margin Bottom"
export const VerticalAlign ="Vertical Align"
export const ImageSizes ="Image Sizes"
export const BadgeColor ="Badge Color"
export const BackgroundColor ="BackgroundColor"
export const ButtonColor ="ButtonColor"
export const BorderRadius = "BorderRadius"
export const FontWeight = "FontWeight"
export const FontStyle = "FontStyle"
export const Float = "Float"
export const Overflow ="Overflow"
export const FontSize ="FontSize"
export const AllBordersColor ="AllBordersColor"
export const BorderWidth = "BorderWidth"
export const Position ="Position"
export const ButtonOutline ="ButtonOutline"

// Nav
export const Dashboard = "Dashboard"
export const Dropdownexample = "Dropdown example"
export const ActiveandDisabledLinks = "Activeand Disabled Links"
export const DefaultNav= "Default Nav"
export const ItemBullets= "Item Bullets"
export const SectionandSeparator= "Section and Separator"
export const Navs= "Navs"
export const Widgets= "Widgets"
export const Layout= "Layout"
export const Sidebar= "Sidebar"
export const LogOut= "Log Out"
export const InlineNav= "Inline Nav"
export const SubNav= "Sub Nav"
export const StaticSubNav = "Static Sub Nav"
export const TreeView= "Tree View"
export const Rating= "Rating"
export const Forms= "Forms"
export const Tables= "Tables"
export const ToggleSubNav= "Toggle Sub Nav"
export const Replied= "Replied"
export const Panding= "Panding"

// Shadow
export const Shadow= "Shadow"
export const BoxShadow= "Box Shadow"
export const Examples = "Examples"
export const ShadowMessage=`While shadows on components are disabled by default in Bootstrap and can be enabled via <code>$enable-shadows</code>, you can also quickly add or remove a shadow with our <code>box-shadow</code> utility classes. Includes support for <code>.shadow-none</code> and three default sizes (which have associated variables to match).`
export const Largershadow= "Larger shadow"
export const Regularshadow= "Regular shadow"
export const Smallshadow= "Small shadow"
export const Noshadow="No shadow"

// Lists
export const Lists= "Lists"
export const Defaultlist= "Default list"
export const Crasjustoodio= "Cras justo odio"
export const Dapibusacfacilisisin= "Dapibus ac facilisis in"
export const Morbileorisus = "Morbi leo risus"
export const Portaacconsecteturac= "Porta ac consectetur ac"
export const Vestibulumateros= "Vestibulum at eros"
export const Linksandbuttons= "Links and buttons"
export const FlushStyle= "Flush Style"
export const Contextualclasses= "Contextual classes"
export const Thisisaprimary= "This is a primary list group item"
export const Thisisasecondary= "This is a secondary list group item"
export const Thisisasuccess= "This is a success list group item"
export const Thisisadanger= "This is a danger list group item"
export const Thisisawarning= "This is a warning list group item"
export const Thisisainfo= "This is a info list group item"
export const Thisisalight= "This is a light list group item"
export const Thisisadark= "This is a dark list group item"
export const Withbadges= "With badges"
export const Customcontent= "Custom content"
export const Listgroupitemheading= "List group item heading"
export const Donecidelitnonmiporta= "Donec id elit non mi porta."
export const Donecidelit="Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit."
export const WithIcon= "With Icon"
export const WithImages= "With Images"
export const WithImageRounded= "With Image Rounded"
export const JavaScriptbehavior= "JavaScript behavior"
export const listprofile= "list-profile"
export const Settings= "Settings"
export const Listdetail="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
export const General= "General"

// Popover
export const Popover= "Popover"
export const BasicExamples = "Basic Examples"
export const Direction="Direction"
export const HTMLelements ="HTML elements"
export const PopoverDetail="lorem ipsum dolor sit amet, consectetur adipisicing elit"
export const Clicktotogglepopover= "Click to toggle popover"
export const Dismissiblepopover= "Dismissible popover"
export const OnHoverTooltip= "On Hover Tooltip"
export const Popoverontop = "Popover on top"
export const Popoveronright= "Popover on right"
export const Popoveronbottom= "Popover on bottom"
export const Popoveronleft= "Popover on left"
export const PopoverContent="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."

// Tooltip
export const Tooltip= "Tooltip"
export const BasicTooltip = "Basic Tooltip"
export const Directions ="Directions"
export const HoverMe= "Hover Me"
export const Popovertitle= "Popover title"
export const Tooltipontop= "Tooltip on top"
export const Tooltiponright= "Tooltip on right"
export const Tooltiponbottom= "Tooltip on bottom"
export const Tooltiponleft= "Tooltip on left"
export const Clickme= "Click me"
export const TooltipwithHTML= "Tooltip with HTML"

// Spinners page
export const Spinners ="Spinners"
export const LoaderStyle = "Loader Style"

// Dropdown
export const Dropdown= "Dropdown"
export const BasicDropdown = "Basic Dropdown"
export const DropdownButton="Dropdown Button"
export const Active= "Active"
export const Action="Action"
export const AnotherAction = "Another Action"
export const SomethingElseHere ="Something Else Here"
export const BasicColorDropdown ="Basic Color Dropdown"
export const SeparatedLink ="Separated Link"
export const DropdownSplitButton =  "Dropdown Split Button"
export const PrimaryButton = "Primary Button"
export const dangerButton ="Danger Button"
export const RoundedDropdown = "Rounded Dropdown"
export const WarningButton ="Warning Button"
export const InfoButton = "Info Button"
export const SuccessButton = "Success Button"
export const SecondaryButton = "Secondary Button"
export const DropdownWithDivider = "Dropdown With Divider"
export const DropdownWithHeader = "Dropdown With Header"
export const DropdownWithDisable = "Dropdown With Disable"
export const DropdownWithDropUp ="Dropdown With DropUp"
export const DropmenuMessage=`Use a class <code>.dropdown-header</code>`
export const Dropdownheader= "Dropdown header"
export const Useaclass= "Use a class"
export const DisableMessage=`Use a class <code>.dropdown-disabled</code>`
export const Normal= "Normal"
export const Disabled= "Disabled"
export const DropupMessage= `Use a class <code>.drop-up</code>`

// Accordion
export const Accordion= "Accordion"
export const BasicAccordion ="Basic Accordion"
export const BasicAccordionMessage=`Using the <a href={href}>card</a> component, you can extend the default collapse behavior to create an accordion.`
export const GroupItem = " Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et."
export const AllCloseAccordion = "All Close Accordion"
export const AllCloseMessage=`Using the <a href={href}>card</a> component, you can extend the default collapse behavior to create an accordion.`
export const ColorAccordion = "Color Accordion"
export const ColorAccordionMessage=`Add <code>.bg-*</code> class to add background color with card-header.`
export const AccordionWithIcon  = "Accordion With Icon on Title"
export const Accordionopencloseicon= "Accordion open close icon"
export const CollapsibleGroupItem = "Collapsible Group Item #"
export const AccordionWithIconMessage=`Add <code>&lt;i&gt;&lt;/i&gt;</code> tag Along with icon class before title text.`
export const AccordionopencloseiconMessage=`Add <code>&lt;i&gt;&lt;/i&gt;</code> tag Along with icon class before title text.`


export const SveltestrapTabs="Sveltestrap Tabs"
export const BasicTabs = "Basic Tabs"
export const Dropdown1 = "Dropdown"
export const Separatedlink = "Separated link"
export const BasicTabsContent = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"
export const TabsbottomleftAlign = "Tabs bottom left Align"
export const TabsWithIcon = "Tabs With Icon"
export const TabsRightAlign= "Tabs Right Align"
export const TabsVertical = "Tabs Vertical"
export const PillTabs = "Pill Tabs"
export const PillTabsWithIcon = "Pill Tabs With Icon"
export const PrimaryColor = "Primary Color"
export const SecondaryColor = "Secondary Color"
export const SuccessColor = "Success Color"
export const InfoColor = "info Color"
export const WarningColor = "Warning Color"
export const DangerColor = "Danger Color"
export const PillDarkcolor = "Pill Dark color"
export const Profile= "Profile"
export const Contact= "Contact"
export const PillDarkMessage = `Add <code>.nav-*</code> class with nav class</span><span>remove  <code>nav-pill</code> class from pill style Tab`
export const PrimaryMessage=`Add <code>.nav-primary</code> class with nav class`
export const SecondaryMessage=`Add <code>.nav-secondary</code> class with nav class`
export const SuccessMessage=`Add <code>.nav-success</code> class with nav class`
export const InfoMessage=`Add <code>.nav-info</code> class with nav class`
export const WarningMessage=`Add <code>.nav-warning</code> class with nav class`
export const DangerMessage=`Add <code>.nav-danger</code> class with nav class`
export const Bootstrap= "Bootstrap"


// Line Tabs page
export const LineTabs = "Line Tabs"
export const SimpleMaterialstyletab ="Simple Material style tab"
export const Materialstylebottomtab="Material style bottom tab"
export const Materialstylelefttab = "Material style left tab"
export const Materialstylerighttab = "Material style right tab"
export const Materialcolortab = "Material color tab"
export const SimpleMessage =`Add <code>.border-tab</code> class with nav class`
export const MaterialMessage=`Add <code>.border-tab</code> class with nav class`
export const LeftMessage=`Add <code>.border-tab</code> class with nav class`
export const RightMessage=`Add <code>.border-tab</code> class with nav class`
export const LinePrimaryMessage=`Add <code>.nav-primary</code> class with nav class`
export const LineSecondaryMessage=`Add <code>.nav-secondary</code> class with nav class`
export const LineSuccessMessage=`Add <code>.nav-success</code> class with nav class`
export const LineInfoMessage=`Add <code>.nav-info</code> class with nav class`


// Scrollable page
export const Scrollable = "Scrollable"
export const Advance = "Advance"
export const ClickandDrag = "Click and Drag"
export const SmallSizeScroll = "Small Size Scroll"
export const VerticalScroll = "Vertical Scroll"
export const BothSideScroll = "Both Side Scroll"
export const HorizontalScroll= "Horizontal Scroll"
export const AlwaysVisibleScroll= "Always Visible Scroll"

// Progress page
export const Progress= "Progress"
export const BasicProgressBars = "Basic Progress Bars"
export const BasicProgressBarsTitle = "Progress components are built with two HTML elements, some CSS to set the width, and a few attributes."
export const SmallProgressBars="Small Progress Bars"
export const SmallProgressBarsMessage = `Use <code> .sm-progress-bar</code>class to change progress size to small:`
export const LargeProgressBars="Large Progress Bars"
export const LargeProgressBarsMessage = `Use <code> .lg-progress-bar</code>class to change progress size to small:`
export const CustomHeightProgressBars = "Custom Height Progress Bars"
export const CustomHeightProgressBarsMessage = `Set a height value on the <code>.progress-bar</code>, so if you change that value the outer <code>.progress </code> will automatically resize accordingly.`
export const ProgressBarsstates = "Progress Bars states"
export const Multiplebars = "Multiple bars"
export const ProgressBarsStriped = "Progress Bars Striped"
export const ProgressBarsStripedMessage=`Add <code>.progress-bar-striped</code> to any <code>.progress-bar</code> to apply a stripe via CSS gradient over the progress bar’s background color.`
export const ProgressBarsanimated ="Progress Bars animated"
export const ProgressBarsanimatedMessage=`The striped gradient can also be animated. Add <code>.progress-bar-animated</code> to <code>.progress-bar </code> to animate the stripes right to left via CSS3 animations.`


// Modal page
export const Modal = "Modal"
export const BasicModal="Basic Modal"
export const Sizesmodal= "Sizes modal"
export const Varyingmodalcontent= "Varying modal content"
export const Newmessage = "New message"
export const Close="Close"
export const Sendmessage ="Send message"
export const Recipient = "Recipient"
export const Modaltitle= "Modal title"
export const Simple= "Simple"
export const Scrollinglongcontent= "Scrolling long content"
export const Verticallycentered= "Vertically centered"
export const CenterContent="Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros."
export const Usingthegrid= "Using the grid"
export const SmallModal= "Small Modal"
export const LargeModal= "Large Modal"
export const Tooltipsandpopovers= "Tooltips and popovers"
export const Popoverinamodal= "Popover in a modal"
export const Tooltipsinamodal= "Tooltips in a modal"
export const SendMessage= "Send Message"
export const Savechanges= "Save changes"

// Alert page
export const Alert = "Alert"
export const ThemeColorAlerts = "Theme Color Alerts"
export const Linkcolorthemecolor = "Link color in theme-color"
export const Dismissing ="Dismissing"
export const AlertWithIcon = "Alert With Icon"
export const LightAlerts = "Light Alerts"
export const Linkcolor ="Link color"
export const OutlineAlerts = "Outline Alerts"
export const OutlineDarkAlerts = "Outline Dark Alerts"
export const AlertWithIconoutline="Just add Any icon before text"
export const AlertWithIconinverse= "Alert With Icon inverse"
export const Textasaction ="Text as action"
export const Additionalcontent = "Additional content"
export const Thisisainfoalertcheckitout= "This is a info alert—check it out!"
export const ThemeMessage=`Theme color Archive just adding class <code>.dark</code>`
export const LinkcolorMessage=`Use the <code>.alert-link</code> utility class to quickly provide matching colored links within any alert`
export const DismissingMessage="To animate alerts when dismissing them, be sure to add the .fade and .show classes."
export const JustaddAnyiconbeforetext= "Just add Any icon before text"
export const AlertIcon="You can check in on some of those fields below."
export const AlertLight="Alerts are available for any length of text, as well as an optional dismiss button."
export const LinkMessage=`Use the <code>.alert-link</code> utility class to quickly provide matching colored links within any alert`
export const DismissingLightMessage="To animate alerts when dismissing them, be sure to add the .fade and .show classes."
export const OutlineMessage =`Outline Archive just adding class <code>.outline</code>`
export const PrimaryContent="This is a primary alert—check it out!"
export const DarkOutLineMessage=`Outline Archive just adding class <code>.outline-2x</code>`
export const AlertIconMessage="Just add Any icon before text"
export const AlertIconInverseMessage=`Use the <code>.inverse</code> class to quickly provide matching colored links within any alert`
export const TextasactionMessage=`Use the <code>.inverse</code> class to quickly provide matching colored links within any alert`
export const dismiss = "dismiss"
export  const ParagraphsMessage="Alerts can also contain additional HTML elements like headings, paragraphs and dividers."
export const Paragraphs="Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content."
export const SubContent="Whenever you need to, be sure to use margin utilities to keep things nice and tidy."
export const Welldone= "Well done!"



// Dropzone page
export const Dropzone = "Dropzone"
export const SingleFileUpload = "Single File Upload"
export const Dropfileshereorclicktoupload = "Drop files here or click to upload."
export const Note = `(This is just a demo dropzone. Selected files are <strong>not</strong> actually uploaded.)`
export const MultiFileUpload = "Multi File Upload"
export const FileTypeValidation = "File Type Validation"
export const Remove= "Remove"


// Layout page
export const Youhave = "You have"
export const Notifications = "Notifications"
export const Searchhere = "Search here....."
export const Follow = "Follow"
export const Experince ="Experince"
export const Follower = "Follower"
export const Copyright = "Copyright 2021-22 © viho All rights reserved."
export const Handcrafted = "Hand crafted & made with"
export const LightLayout ="UNLIMITED COLOR"
export const DarkLayout = "Dark Layout"
export const MixLayout ="Mix Layout"
export const LayoutType= "Layout Type"
export const LTR= "LTR"
export const RTL= "RTL"
export const Box= "Box"
export const SidebarType = "Sidebar Type"
export const Livecustomizer ="Live customizer"

// Buttons
export const Buttons= "Buttons"
export const DefaultStyle = "Default Style"
export const DefaultButtons= "Default Buttons"
export const Sveltestrapstatebuttons= "Sveltestrap state buttons"
export const LargeButtons= "Large Buttons"
export const LargeButtonsMessage=`Add <code>.btn-lg</code> class for large size buttons`
export const SmallButtons= "Small Buttons"
export const SmallButtonsMessage=`Add <code>.btn-sm</code> class for small size buttons`
export const ExtraSmallButtons= "Extra Small Buttons"
export const ExtraSmallButtonsMessage=`Add <code>.btn-xs</code> class for extra small size buttons`
export const ActiveButtons= "Active Buttons"
export const ActiveButtonsMessage=`Add <code>.active</code> class for active state`
export const DisableButton = "Disable Button"
export const DisableButtonMessage=`Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled button`
export const CustomStateButtons= "Custom State Buttons"
export const CustomStateButtonsMessage=`The <code>.btn</code> class used with <code>&lt;button&gt;</code>, <code>&lt;a&gt;</code> and <code>&lt;input&gt;</code> elements.`
export const OutlineButtons= "Outline Buttons"
export const OutlineButtonsMessage=`Add <code>.btn-outline-*</code> class for border button`
export const BoldBorderoutlinebuttons= "Bold Border outline buttons"
export const BoldBorderoutlinebuttonsMessage=`Add <code>.btn-outline-*-2x</code> class for bold outline`
export const OutlineLaragebuttons = "Outline Larage buttons"
export const LightButton = "Light Button"
export const OutlineLaragebuttonsMessage=`Add <code>.btn-outline-*</code> class for outline and <code>.btn-lg"</code> class for large button`
export const OutlineSmallbuttons= "Outline Small buttons"
export const OutlineSmallbuttonsMessage=`Add
<code>.btn-outline-*</code>
class for outline and
<code>.btn-sm</code>
class for small button`
export const OutlineExtraSmallbuttons= "Outline Extra Small buttons"
export const OutlineExtraSmallbuttonsMessage=`Add <code>.btn-outline-*</code> class for outline and" <code>.btn-sm</code> class for extra small button`
export const DisabledOutlinebuttons= "Disabled Outline buttons"
export const DisabledOutlinebuttonsMessage=`Add <code>.disabled</code> class or <code>disabled='disabled'</code> attribute for disabled state`
export const GradienButtons = "Gradien Buttons"
export const GradienButtonsMessage=`Add <code>.btn-*-gradien</code> class for gradien button`
export const FlatButtons = "Flat Buttons"
export const FlatButtonsMessage=`Add
<code>.btn-square</code>
class for flat button`
export const EdgeButtons = "Edge Buttons"
export const EdgeButtonsMessage=`Add
<code>.btn-pill</code>
class for edge button`
export const LargepillButtonsMessage=`Add<code>.btn-pill</code> and <code>.btn-lg</code> class for large size buttons`
export const SmallpillButtonsMessage=`Add <code>.btn-pill</code> and <code>.btn-sm</code> class for small size buttons`
export const ExtraSmallpillButtonsMessage=`Add <code>.btn-pill</code> and <code>.btn-xs</code> class for extra small size buttons`
export const OutlinepillButtonsMessage=`Add <code>.btn-pill</code> and <code>.btn-outline-*</code> class for border button`
export const BoldBorderoutlinepillbuttonsMessage=`Add <code>.btn-pill</code>
and <code>.btn-outline-*-2x</code> class for bold outline`
export const OutlineLaragepillbuttonsMessage=`Add <code>.btn-pill</code>
,<code>.btn-outline-*</code> class for outline and" <code>.btn-lg"</code> class for large button`
export const OutlineSmallpillbuttonsMessage=`Add
<code>.btn-pill</code>,
<code>.btn-outline-*</code>
 and
<code>.btn-sm</code>
class for small button`
export const OutlineExtraSmallpillbuttonsMessage=`Add <code>.btn-pill</code>
, <code>.btn-outline-*</code> class for outline and <code>.btn-sm</code> class for extra small button`
export const GradienpillButtonsMessage=` Add
<code>.btn-pill</code>
and
<code>.btn-*-gradien</code>`
export const RaisedButtons ="Raised Buttons"
export const RaisedButtonsMessage=`Add
<code>.btn-pill</code>
'and'
<code>.btn-air-*</code>
class for raised button`
export const ButtonGroup = "Button Group"
export const BasicButtonGroup = "Basic Button Group"
export const Left = "Left"
export const Middle = "Middle"
export const Right = "Right"
export const EdgeButtonGroup = "Edge Button Group"
export const FlatButtonGroup = "Flat Button Group"
export const LargeButtonGroup = "Large Button Group"
export const LargeEdgesButtonGroup = "Large Edges Button Group"
export const OutlineCustombuttongroup = "Outline Custom button group"
export const OutlineButtonGroup = "Outline Button Group"
export const OutlineEdgeButtonGroup = "Outline Edge Button Group"
export const OutlineFlatButtonGroup = "Outline Flat Button Group"
export const RadioButtonGroup= "Radio Button Group"
export const RadioButtonGroupMessage = ` Add
<code>.active</code>
for active state and
<code>.disabled</code>
class or
<code>disabled='disabled'</code>
attribute`
export const Makeverticalbuttons = "Make vertical buttons"
export const Vertical = "Vertical"
export const Makenestingbuttons = "Make nesting buttons"
export const CheckboxButtonGroup = "Checkbox Button Group"
export const CheckboxButtonGroupMessage=`Add
<code>.active</code>
for active state and
<code>.disabled</code>
class or
<code>disabled='disabled'</code>
attribute`
// Flagicon
export const FlagIcons = "Flag Icons"
export const Icons= "Icons"
export const FontAwesomeIcon = "Font Awesome Icon"
export const CurrencyIcons= "Currency Icons"
export const WebAppIcons = "Web App Icons"
export const SpinnerIcons = "Spinner Icons"
export const FormControlIcons= "Form Control Icons"
export const TextEditorIcons= "Text Editor Icons"
export const DirectionalIcons= "Directional Icons"
export const VideoPlayerIcons= "Video Player Icons"
export const BrandPlayerIcons = "Brand Player Icons"
export const MedicalPlayerIcons = "Medical Player Icons"
export const ICOIcon ="ICO Icon"
export const AbstractIcons = "Abstract Icons"
export const AnimalIcons = "Animal Icons"
export const BrandIcons = "Brand Icons"
export const BusinessIcons = "Business Icons"
export const ChartsIcons= "Charts Icons"
export const ConstructionIcons = "Construction Icons"
export const DeviceIcons = "Device Icons"
export const EductionIcons = "Eduction Icons"
export const EmotionIcons = "Emotion Icons"
export const FileIcons = "File Icons"
export const FoodIcons = "Food Icons"
export const KidsIcons = "Kids Icons"
export const LawIcons  ="Law Icons"
export const MathematicalIcons = "Mathematical Icons"
export const MedicalIcons="Medical Icons"
export const MobileUiIcons = "Mobile Ui Icons"
export const MultimediaIcons = "Multimedia Icons"
export const PaymentIcons = "Payment Icons"
export const PersonIcons = "Person Icons"
export const SearchIcons = "Search Icons"
export const SocialIcons = "Social Icons"
export const SportIcons= "Sport Icons"
export const TravelIcons= "Travel Icons"
export const WeatherIcons= "Weather Icons"
export const WebapplicationIcons = "Webapplication Icons"
export const ThemifyIcon = "Themify Icon"
export const ArrowsDirection = "Arrows & Direction Icons"
export const ControlIcons= "Control Icons"
export const BrandIcon= "Brand Icon"
export const FeatherIcons=  "Feather Icons"
export const WeatherIcon= "Weather Icon"
export const WeatherIconsWithAnimations = "Weather Icons With Animations"
export const Copytext = "Copy text"
// toaster
export const Toaster = "Toaster"
export const BasicExample= "Basic Example"
export const DangerNotification= "Danger Notification"
export const SuccessNotification= "Success Notification"
export const InfoNotification= "Info Notification"
export const WarningNotification ="Warning Notification"
export const CustomDirectionExample ="Custom Direction Example"
export const TopCenter= "Top Center"
export const BottomCenter= "Bottom Center"
export const BottomLeft = "Bottom Left"
export const RightBottom= "Right Bottom"
export const CustomAutoPlayExample = "Custom Auto-Play Example"
export const AutoClosein15000Sec = "AutoClose in 15000 Sec"
export const AutoClosein5000Sec = "AutoClose in 5000 Sec"
export const AutoClosein1000Sec= "AutoClose in 1000 Sec"
export const AutoClosein500Sec ="AutoClose in 500 Sec"

// Rating
export const Ratings= "Rating"
export const HoverRating= "Hover Rating"
export const RatedHoverRating = "Rated Hover Rating"

// Alert
export const SweetAlert= "Sweet Alert"
export const Basic= "Basic"
export const WithTitlealert= "With Title alert"
export const Successalert= "Success alert"
export const Infoalert= "Info alert"
export const Warningalert= "Warning alert"
export const AdvancedState= "Advanced State"
export const Information= "Information"
export const AlertState= "Alert State"

// Ribbons
export const BonusUI= "Bonus UI"
export const Dropzones = "Dropzone"
export const Ribbons = "Ribbons"
export const Ribbon= "Ribbon"
export const Paginations= "Pagination"
export const RangeSlide= "Range Slider"
export const DraggableCards = "Draggable Card"
export const WithPips= "With Pips"
export const PipsLable= "Pips Lable"
export const MinMaxRange ="Min - Max Range"
export const Bindthevalue= "Bind the value"
export const MultipleValues = "Multiple Values"
export const CustomLable = "Custom Lable"
export const Prefix= "Prefix"
export const Suffix= "Suffix"
export const ValueBounds= "Value Bounds"
export const ResultofBoundValue= "Result of Bound Value"
export const ColoredRibbons= "Colored Ribbons"
export const Dummytext = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text."
export const Previous= "Previous"
export const Next= "Next"
export const Location= "Location"
export const BOD= "BOD"

// OwlCarousel
export const OwlCarousel = "Owl Carousel"
export const ResponsiveExample = "Responsive Example"
export const CenterExample ="Center Example"
export const MergeExample = "Merge Example"
export const AutoplayExample = "Auto Play Example"
export const AutoHeightExample= "Auto Height Example"
export const MouseWheelExample = "Mouse Wheel Example"
export const RighttoLeftExample = "Right to Left Example"
export const LazyloadExample = "Lazy load Example"

// Breadcrumb
export const Breadcrumbname= "Breadcrumb"
export const DefaultSveltestrapBreadcrumb  = "Default Sveltestrap Breadcrumb "
export const Sveltestrap = "Sveltestrap"
export const BreadcrumbMessage = `use class
<code>.breadcrumb to ol</code>`
export const NavBreadcrumb = "Nav Breadcrumb"
export const NavBreadcrumbMessage=`use class
<code>.breadcrumb to nav</code>
similar to navigation`
export const ColoredBreadcrumb ="Colored Breadcrumb"
export const ColoredBreadcrumbMessage=`use class
<code>.breadcrumb-colored .bg-primary`
export const Data= "Data"
export const Library = "Library"

// RangeSlide
export const IconRangeSlider ="Icon Range Slider"
export const Default= "Default"

//  Steps
export const Steps = "Steps"
export const DefaultStep= "Default Step"
export const Stepwithicon = "Step with icon"
export const StepStates = "Step States"
export const StepStatesMessage=`A u-step with classname <code>.done</code> A u-step with classname <code>.error</code>A u-step with classname <code>.current</code>A u-step with classname <code>.disabled</code>`
export const StepSizing = "Step Sizing"
export const StepSizingMessage=`A step with classname <code>.u-steps-xs</code><code>.u-steps-sm</code><code>.u-steps-lg</code>`
export const VerticalStep = "Vertical Step"
export const DefaultPearlsSteps ="Default Pearls Steps"
export const PearlsStepswithicon= "Pearls Steps with icon"
export const PearlsStepSizing = "Pearls Step Sizing"
export const PearlsStepSizingMessage=`A Pearls step with classname <code>.u-pearls-xs</code><code>.u-pearls-sm</code><code>.u-pearls-lg</code>`
export const PearlsStepStates = "Pearls Step States"
export const PearlsStepStatesMessage=`A pearls step states with different class<code>.done</code><code>.currunt</code><code>.error</code><code>.disabled</code>`

// Treeview
export const Treeview= "Tree view"
export const BasicTree= "Basic Tree"
export const CheckboxTree= "Checkbox Tree"
export const CustomizedTree= "Customized Tree"
export const DragTree= "Drag Tree"
export const Cssone= "Css one"
export const Csstwo= "Css two"
export const Jsone= "Js one"
export const Jstwo = "Js two"
export const SubFile= "Sub File"
export const indexfile= "index file"
export const Scsstwo= "Scss two"
export const Js= "Js"

// Image Cropper
export const ImageCropper ="Image Cropper"

// BasicCard
export const BasicCard= "Basic Card"
export const CardContent = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled."
export const IconinHeading = "Icon in Heading"
export const CardsubTitle = "Card sub Title"
export const CardsubMessage=`Using the <a href="javascript:void(0)">card</a> component, you can extend the default collapse behavior to create an accordion.`
export const CardWithFooter=  "Card With Footer"
export const CardWithFootercontent="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the the industry's standard dummy text ever."
export const PrimaryColorCard= "Primary Color Card"
export const ColorCardContent="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the."
export const SecondaryColorCard= "Secondary Color Card"
export const SuccesscolorCard = "Success color Card"
export const DangercolorCard ="Danger color Card"
export const WarningcolorCard= "Warning color Card"
export const PrimaryColorHeader= "Primary Color Header"
export const PrimaryColorBody= "Primary Color Body"
export const PrimaryColorFooter= "Primary Color Footer"

// Creative Card
export const CreativeCard= "Creative Card"
export const Cards= "Cards"
export const Tabbedcard = "Tabbed card"
export const SimpleTab= "Simple Tab"
export const BasicTabsContent1 = "Printing and typesetting industry.Lorem Ipsum is simply dummy text of the Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions"
export const BasicTabsContent2 = "The printing and typesetting industry. Lorem Ipsum has been Lorem Ipsum is simply dummy text the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software "
export const TabWithIcon= "Tab With Icon"
export const ColorTab= "Color Tab"
export const ColorOption="Color Option"
export const Materialtab= "Material tab"
export const Materialtabwithicon = "Material tab with icon"
export const Materialtabwithcolor = "Material tab with color"

// Sticky
export const Sticky = "Sticky"
export const StickyNote = "Sticky Note"
export const AddNewNote = "Add New Note"

// timeline1
export const Timeline = "Timeline"
export const Example = "Example"

// Gallery
export const Gallery= "Gallery"
export const GalleryGrid = "Gallery Grid"
export const IMAGEGALLERY = "IMAGE GALLERY"
export const GalleryGridWithDescription = "Gallery Grid With Description"
export const PortfolioTitle= "Portfolio Title"
export const Gallarydata= "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy."
export const ImageHoverEffects = "Image Hover Effects"

// Blog
export const Blogs ="Blog"
export const BlogDetail="Blog Detail"
export const BlogSingle = "Blog Single"
export const Blogheader = "All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet."
export const Blogpara=" Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
export const Blogpara2="It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like"
export const CommentContent = "CommentContent"
export const AddPost= "Add Post"
export const Category= "Category"
export const Content = "Content:"
export const Post = "Post"
export const Looksgood = "Looks good!"
export const Type = "Type:"
export const Text = "Text"
export const Image = "Image"
export const Audio = "Audio"
export const Video = "Video"
export const blogdetail="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt."
export const Discard= "Discard"

// FAQ
export const FAQ= "FAQ"
export const QuickQuestionsareanswered= "Quick Questions are answered"
export const LatestUpdates= "Latest Updates"
export const SeeAll= "See All"
export const Navigation="Navigation"
export const Searcharticles= "Search articles"
export const Latestarticlesandvideos= "Latest articles and videos"
export const FeaturedTutorials= "Featured Tutorials"

// Support Ticket
export const SupportTickets= "Support Ticket"
export const Listofticketopendbycustomers= "List of ticket opend by customers"
export const Profit= "Profit"
export const Loss = "Loss"
export const SupportTicketList = "Ticket List"

// Map JS
export const MapJS= "Map JS"
export const Maps= "Maps"
export const LeafletMaps= "Leaflet Map"
export const BelowMapisdisplayingtheworldmap= "Below Map is displaying the world map."

// Knowledgebase
export const Knowledgebases= "Knowledgebase"
export const KnowledgeCategory= "Knowledge Category"
export const HowCanIhelpyou= "How Can I help you?"
export const Knowledgeaticlesbycategory= "Knowledge articles by category"
export const BrowseArticles = "Browse Articles"
export const KnowledgeDetails = "Knowledge Details"
export const Knowledgefilter= "Knowledge filter"
export const WhyChoose = "Why Choose Knowledge Course ?"
export const UpcomingCourses= "Upcoming Courses"
export const KnowledgeCategories= "Knowledge Categories"

// Cards View
export const CardsView= "Cards View"
export const JobSearch= "Job Search"
export const jobfilter= "job filter"
export const Filter = "Filter"
export const Findjobs = "Find jobs"
export const JobTitle= "Job Title"
export const AllJobTitle= "All Job Title"
export const Industry= "Industry"
export const AllIndustries= "All Industries"
export const Specificskills= "Specific skills"
export const AllSkills= "All Skills"
export const ListView = "List View"
export const JobDetails = "Job Details"
export const ProductDesigner="Product Designer (UI/UX Designer)"
export const EndlessUnitedStates= "Endless - United States"
export const Applyforthisjob= "Apply for this job"
export const  JobDescription = "Job Description"
export const JobDescriptions="Endless is looking for a UI/UX Designer to join our team. The world is seeing an explosion in the amount and variety of location-baWe are looking for a versatile UX/UI Designer to join our growing design team. Our designers contribute to clients’ projects at all stages of development. We might start from scratch, conducting user and stakeholder interviews, making personas and journey maps, and continue on to iterating on designs and prototypes through delivering final assets for launch. We might come into the middle of an in-flight program-size project and conduct analysis and usability correction or feature enhancement. We might provide research and vision for handoff to an internal development team."
export const Savethisjob= "Save this job"
export const Share= "Share"
export const Similarjobs= "Similar jobs"
export const Apply = "Apply"
export const UIDesigner= "UI Designer"
export const EndlessTelecom = "Endless Telecom & Technologies , NY "
export const PersonalDetails= "Personal Details"
export const BirthDate= "Birth Date"
export const YourEducation= "Your Education"
export const UploadYourFiles= "Upload Your Files"
export const YourExperience= "Your Experience"
export const LearningList= "Learning List"
export const Learningdetail = "inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit.inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit.inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo."
export const bottomdetail = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has."
export const learningfilter= "learning filter"
export const FindCourse= "Find Course"
export const DetailedCourse = "Detailed Course"
export const Learning = "Learning"
export const Comment= "Comment"
// Sample Page
export const SamplePage= "Sample Page"
export const Pages = "Pages"
export const SamplePageMessage="lorem ipsum dolor sit amet, consectetur adipisicing elit"
export const detail= "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."

// error
export const Error1="Oops! This Page is Not Found."
export const ErrorMassge = "The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved."
export const Errorbtn = "BACK TO HOME PAGE"
export const Error2="page not found"
export const Error3="Sorry, something goes wrong"
export const Error4="500 - Internal server error"

// comingsoon
export const WEARECOMINGSOON = "WE ARE COMING SOON"

// authentication
export const Welcomeback = "Welcome back! Log in to your account."
export const Rememberpassword= "Remember password"
export const Forgotpassword= "Forgot password?"
export const Signin= "Sign in"
export const Signupwith= "Sign up with"
export const Signinwith= "Sign in with"
export const Donthaveaccount=  "Don't have account?"
export const CreateAccount= "Create Account"
export const Enteryour = "Enter your personal details to create account"
export const YourName= "Your Name"
export const Unlock= "unlock"
export const EnteryourPassword= "Enter your Password"
export const Alreadyhaveanaccount = "Already have an account?"
export const ResetYourPassword = "Reset Your Password"
export const EnterYourMobileNumber = "Enter Your Mobile Number"
export const IfdontreceiveOTP = "If don't receive OTP?"
export const Resend= "Resend"
export const EnterOTP= "Enter OTP"
export const CreateYourPassword= "Create Your Password"
export const NewPassword= "New Password"
export const RetypePassword = "Retype Password"
export const Alreadyhaveanpassword= "Already have an password?"
export const MAINTENANCE = "MAINTENANCE"
export const Logout= "Log out"

// Product
export const Product= "Product"
export const Ecommerces = "Ecommerce"
export const ProductDetails = "Product Details"
export const ProDiscription ="Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo."
export const Filters= "Filters"
export const NewProducts= "New Products"

// Product Page
export const ProductPage="Product Page"
export const WomenPinkshirt= "Women Pink shirt."
export const discription5 = "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that."
export const Shareit= "share it"
export const RateNow= "Rate Now"
export const CartEmpty= "Your Cart is Empty"
export const ExploreShortlistItems ="Explore more shortlist some items."
export const continueshopping = "continue shopping"
export const checkout= "check out"
export const AddtoCart= "Add to Cart"
export const AddToWishList= "AddTo Wish List"
export const BuyNow= "Buy Now"
export const Brand= "Brand"
export const Quantity= "Quantity"
export const ViewDetails= "View Details"
export const Featured = 'Featured';
export const LowestPrices = 'Lowest Prices';
export const HighestPrices = 'Highest Prices';
export const ShowingProducts = 'Showing Products 1 - 24 Of 200 Results';
// Invoice
export const Invoice="Invoice"
export const ProjectDescription= "Project Description"
export const discription4 = "Lorem Ipsum is simply dummy text of the printing and typesetting industry.It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."

// Cart
export const Cart= "Cart"

// Checkout
export const Checkout = "Checkout"
export const BillingDetails = "Billing Details"
// Pricing
export const Pricing= "Pricing"
export const Becomemember= "Become member"
export const SimplePricingCard= "Simple Pricing Card"
export const Subscribe = "Subscribe"

// Wishlist
export const Wishlist= "Wishlist"

// Productlist
export const Productlist = "Product List"
export const Individualcolumn = "Individual column searching (text inputs)" 
export const DataTablesSearching ="The searching functionality provided by DataTables is useful for quickly search through the information in the table - however the search is global, and you may wish to present controls that search on specific columns."

export const PaymentDetails="Payment Details"
export const Creditcard ="Credit card"
export const Debitcard = "Debit card"
export const COD="COD"
export const NetBanking="Net Banking"
export const EMI="EMI"
export const CheckPayments= "Check Payments"
export const CashOnDelivery= "Cash On Delivery"
export const PayPal= "PayPal"
export const PlaceOrder= "Place Order"
export const Total= "Total"
export const Subtotal= "Subtotal"
export const Cuba= "Cuba"
export const SelectType= "Select Type"
export const Master= "Master"
export const Visa= "Visa"
export const ExpirationDate= "Expiration Date"
export const SignUp= "Sign Up"

// OrderHistory
export const OrderHistory = "Order History"
export const NewOrders= "New Orders"
export const Datatableorderhistory= "Datatable order history"
// Contacts
export const Contacts= "Contacts"
export const Contactfilter= "contact filter"
export const NewContacts= "New Contacts"
export const AddContact= "Add Contact"
export const Phone= "Phone"
export const Mobile= "Mobile"
export const Work= "Work"
export const Others= "Others"
export const Personal= "Personal"
export const AddCategory= "Add Category"
export const Organization= "Organization"
export const ContactHistory= "ContactHistory"
export const Contactmodified = "Contact has not been modified yet."
export const ContactCreated= "Contact Created"
export const ContactEmail="Contact is created via mail"
export const Printpreview= "Print preview"
export const Gender= "Gender"
export const Followup= "Follow up"
export const Favorites= "Favorites"
export const Ideas= "Ideas"
export const NoDataFound= "No Data Found"
export const History= "History"
export const MobileNo= "Mobile No"

// Tasks
export const Tasks ="Tasks"
export const NewTask= "New Task"
export const TaskTitle = "Task Title"
export const Remindon = "Remind on"
export const Mail = "Mail"
export const Print =  "Print"
export const TodayTasks= "Today's Tasks"
export const Notaskduetoday  ="No task due today."
export const DelayedTasks ="Delayed Tasks"
export const UpcomingTasks =  "Upcoming Tasks"
export const ThisWeekTasks = "This Week Tasks"
export const ThisMonthTasks  ="This Month Tasks"
export const Assignedtome = "Assigned to me"
export const Mytasks = "My tasks"
export const Subtask = "Sub task"
export const Description = "Description"
// User Profile page
export const UserProfile= "User Profile"
export const User = "User"
export const discription="you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet."
export const discription2 = "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source .Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC,making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source"
export const UserEdit ="User Edit"
export const UserCard = "User Card"
export const Uikits = "Ui-kits"
export const Following= "Following"
export const Likes= "Likes"
export const SocialNetworks = "Social Networks"
export const Followers = "Followers"
export const Postreat="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
export const EditProfiles = "Edit Profile"
export const AddprojectsAndUpload = "Add projects And Upload"
export const Edit= "Edit"
export const Delete= "Delete"
export const Company ="Company"
export const Username= "Username"
export const Emailaddress= "Email address"
export const Like= "Like"
export const Country = "Country"
export const Bio = "Bio"
export const EmailAddress= "Email-Address"
//Email
export const EmailApp = "Email App"
export const EmailApplication = "Email Application"
export const emailfilter= "email filter"
export const NEWMAIL= "NEW MAIL"
export const Inbox= "Inbox"
export const More="More"
export const SEND= "SEND"
export const NewMessage = "New Message"
export const Hello= "Hello"
export const GoodMorning = "Dear Sir Good Morning,"
export const Detail ="Elementum varius nisi vel tempus. Donec eleifend egestas viverra."
export const Detail2 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur non diam facilisis, commodo libero et, commodo sapien. Pellentesque sollicitudin massa sagittis dolor facilisis, sit amet vulputate nunc molestie. Pellentesque maximus nibh id luctus porta. Ut consectetur dui nec nulla mattis luctus. Donec nisi diam, congue vitae felis at, ullamcorper bibendum tortor. Vestibulum pellentesque felis felis. Etiam ac tortor felis. Ut elit arcu, rhoncus in laoreet vel, gravida sed tortor."
export const Detail3 = "In elementum varius nisi vel tempus. Donec eleifend egestas viverra. Donec dapibus sollicitudin blandit. Donec scelerisque purus sit amet feugiat efficitur. Quisque feugiat semper sapien vel hendrerit. Mauris lacus felis, consequat nec pellentesque viverra, venenatis a lorem. Sed urna"
export const ATTACHMENTS= "ATTACHMENTS"
export const DownloadAll= "Download All"
export const Reply= "Reply"
export const ReplyAll= "Reply All"
export const Forward= "Forward"
export const EmailCompose= "Email Compose"
export const cancel = "cancel"
export const Subject = "Subject"
export const save = "save"

// for chat
export const Chat= "Chat"
export const VideoChat= "Video Chat"
export const Typing= "Typing..."
export const LastSeen="Last Seen 3:55 PM"
export const ENDCALL= "END CALL"
export const Established = "Established fact that a reader will be distracted"
export const ChatApp= "Chat App"
export const Send="Are we meeting today? Project has been already finished and I have results to show you."
// Project
export const Project = "Project"
export const ProjectList  ="Project List"
export const ProjectCreate="Project Create"
export const ProjectTitle="Project Title"
export const Clientname= "Client name"
export const ProjectRate= "Project Rate"
export const ProjectType= "Project Type"
export const Priority= "Priority"
export const ProjectSize= "Project Size"
export const Startingdate= "Starting date"
export const Endingdate= "Ending date"
export const SomeDetails= "Enter some Details"
export const Uploadproject= "Upload project file"
export const DropFiles = "Drop files here or click to upload."
export const Add= "Add"
export const CreateNewProject= "Create New Project"

// FileManager
export const FileManager= "File Manager"
export const Filefilter= "file filter"
export const AllFile= "All Files"
export const Recentlyopenedfiles = "Recently opened files"
export const Folders= "Folders"
export const Files= "Files"
export const Pricingplan = "Pricing plan"
export const AddNew="Add New"
export const Upload= "Upload"
// Table
export const SimpleDataTable= "Simple Data Table"
export const BasicTables= "Basic Tables"
export const BorderTables= "Border Tables"
export const SizingTables= "Sizing Tables"
export const StylingTables= "Styling Tables"
export const ID= "ID"
export const Name= "Name"
export const CreateOn= "Create On"
export const BasicTablesMessage = `Use a class <code> table </code> to any table.`
export const InverseTablewithPrimarybackground = "Inverse Table with Primary background"
export const InverseTablewithPrimarybackgroundMessage=`Use a class
<code>
.bg-info, .bg-success, .bg-warning and .bg-danger classes.
</code>
with light text on dark backgrounds inside table element.
<span class="d-block">
To set the light background color use .bg-[color] class where [color] is the value of your selected color from stack color palette. So for teal color background class will be .bg-teal</span>`
export const ResponsiveTable ="Responsive Table"
export const ResponsiveTableMessage=`A
<code>&lt;caption&gt;</code>
functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.`
export const BorderBottomColor = "Border Bottom Color"
export const BorderBottomColorMessage=`Example of a table head border with
<code>custom</code>
color. According to the custom color system options, you can set any of predefined colors by adding
<code>.border-bottom-*</code>
class to the table head row. This technique works with all border styles demonstrated above.`
export const BorderlessBorders = "Borderless Tables"
export const BorderlessBordersMessage=`Example of
<code>horizontal</code>
table borders. This is a default table border style attached to
<code>.table</code>
class.All borders have the same grey color and style, table itself doesn't have a border, but you can add this border using
<code>.table-bordernone</code>
class added to the table with
<code>.table</code>
class.`
export const HorizontalBorders = "Horizontal Borders"
export const HorizontalBordersMessage=`Example of
<code>horizontal</code>
table borders.This is a default table border style attached to
<code>.table</code>
class.All borders have the same grey color and style, table itself doesn't have a border, but you can add this border using
<code>.table-border-horizontal</code>
class added to the table with
<code>.table</code>
class.`
export  const DashedBorders = "Dashed Borders"
export const DashedBordersMessage=`Example of a
<code>dashed</code>
border inside table head. This border has
<code>3px</code>
width,
<code>dashed</code>
style and inherits all styling options from the default border style. Visually it displays table
<code>head</code>
and
<code>body</code>
as 2 separated table areas. To use this border add
<code>.border-dashed</code>
to the table head row.`
export const VerticalBorders = "Vertical Borders"
export const VerticalBordersMessage=`Example of
<code>Vertical</code>
table borders. This is a default table border style attached to
<code>.table</code>
class.All borders have the same grey color and style, table itself doesn't have a border, but you can add this border using
<code>.table-border-vertical</code>
class added to the table with
<code>.table</code>
class.`
export const LargeTables ="Large Tables"
export const LargeTablesMessage=`Example of large table, Add
<code>.table-de</code>
class to the
<code>.table</code>
to create a table with large spacing. larger table all rows have
<code>0.75rem</code>
height.`
export const DefaultTables = "Default Tables"
export const DefaultTablesMessage=`Example of large table, Add
<code>.table-de</code>
class to the
<code>.table</code>
to create a table with large spacing. larger table all rows have
<code>0.75rem</code>
height.`
export const SmallTables = "Small Tables"
export const SmallTablesMessage=`Example of small table, Add
<code>.table-sm</code>
class to the
<code>.table</code>
to create a table with small spacing. Small table all rows have
<code>0.3rem</code>
height`
export const CustomTableColor = "Custom Table Color"
export const CustomTableColorMessage=`Use class
<code>table-*</code>
inside table element.`
export const TableHeadOptions = "Table Head Options"
export const TableHeadOptionsMessage=`Use class
<code>.table-primary</code>
inside thead tr element.`
export const TableFooterStyling = "Table Footer Styling"
export const TableFooterStylingMessage=`Use class
<code>table-info</code>
,
<code>table-success</code>
,
<code>table-success</code>
,
<code>table-info</code>
,
<code>table-danger</code>
,
<code>table-primary</code>
,
<code>table-secondary</code>
,
<code>table-light</code>
,
<code>table-active</code>
and also use
<code>bg-*</code>
inside tfoot  element.`
export const InverseTable=  "Inverse Table"
export const InverseTableMessage = `Use a class <code>table-inverse</code> inside table element.`
export const HoverableRows = "Hoverable Rows"
export const HoverableRowsMessage=`Use a class
<code>
  .bg-info, .bg-success, .bg-warning and .bg-danger classes.
</code>
with light text on dark backgrounds inside table element.
<span class="d-block">
  To set the light background color use .bg-[color] class where [color] is the value of your selected color from stack color palette. So for teal color background class will be .bg-teal`
  export const ContextualclassesMessage = `Use contextual classes to color table rows or individual cells. you may use Classes <code>table-primary</code>,<code>table-secondary</code>,<code>table-success</code>,<code>table-info</code>,<code>table-warning</code>,<code>table-danger</code>,<code>table-light</code>,<code>table-active</code> in<code>tr</code>`
  export const Textorbackgroundutilities = "Text or background utilities"
  export const TextorbackgroundMessage=`Regular table background variants are not available with the inverse table, however, you may use Classes <code>bg-dark</code>,<code>bg-warning</code>,<code>bg-success</code>,<code>bg-info</code>,<code>bg-danger</code>,<code>bg-primary</code>,<code>bg-secondary</code>,<code>bg-light</code> in<code>td</code>`
  export const Tableheadoptions = "Table head options"
  export const TableheadoptionsMessage = `Similar to tables and dark tables, use the modifier classes <code>.thead-dark</code>  to make <code>thead</code> appear light or dark gray.`
  export const Tableheadoptions2Message = `Similar to tables and dark tables, use the modifier classes <code>.bg-*</code>and  <code>.thead-light</code> to make <code>thead</code> appear light or dark gray.`
export const StripedRow = "Striped Row"
export const StripedRowMessage = `Use <code>.table-striped</code> to add zebra-striping to any table row within the <code></code>. This styling doesn't work in IE8 and below as :nth-child CSS selector isn't supported.`
export const StripedRowwithInverseTable = "Striped Row with Inverse Table"
export const StripedRowwithInverseTableMessage  =`Use <code>.table-striped</code> to add zebra-striping to any table row within the <code></code>. This styling doesn't work in IE8 and below as :nth-child CSS selector isn't supported.`
export const Caption = "Caption"
export const CaptionMessage = `A <code>&lt;caption&gt;</code> functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.`
export const BreckpointSpecific = "Breckpoint Specific"
export const BreckpointSpecificMessage  =`Use  <code>.table-responsive{-sm|-md|-lg|-xl}</code> functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.`
export const ExtraLargeTables= "Extra Large Tables"
export const ExtraLargeTablesMessage = `Example of Extra large table, Add <code>.table-xl</code> class to the <code>.table</code> to create a table with extra large spacing. Extra larger table all rows have <code>1.25rem</code> height.`
export const ExtraSmalltable= "Extra Small table"
export const ExtraSmalltableMessage = `Extra Small table</h5><span>Example of small table, Add <code>.table-xs</code> class to the <code>.table</code> to create a table with extra small spacing. Small table all rows have <code>1.5rem</code> height`
export const BothBordeds= "Both Bordeds"
export const BothBordedsMessage = `Example of <code>horizontal</code> table borders. This is a default table border style attached to <code> .table</code> class.All borders have the same grey color and style, table itself doesn't have a border, but you can add this border using<code> .table-bordered</code>class added to the table with <code>.table</code>class.`
export const DefaultTableBorder = "Default Table Border"
export const DefaultTableBorderMessage = `Example of <code>Default Table Border</code>.This is a default table border style attached to <code>.table</code> class.All borders have the same grey color and style, table itself doesn't have a border, but you can add this border using<code> .table</code>class added to the table with <code>.table</code>class.`
export const SolidBorder= "Solid Border"
export const SolidBorderMessage = `Example of a <code>solid</code> border inside table <code>thead</code>. This border inherits all styling options from the default border style, the only difference is it has <code>2px</code> width. Sometimes it could be useful for visual separation and addition highlight. To use this border add <code>.border-solid</code> to the table head row. This border style works only with row borders.`
export const DoubleBorder= "Double Border"
export const DoubleBorderMessage = `Example of a <code>double</code> border inside table head. This border has <code>3px</code> width, <code>double</code> style and inherits all styling options from the default border style. Visually it displays table <code>head</code> and <code>body</code> as 2 separated table areas. To use this border add <code>.border-double</code> to the table head row.`
export const DottedBorder = "Dotted Border"
export const DottedBorderMessage = `Example of a <code>dotted</code> border inside table head. This border has <code>3px</code> width, <code>dotted</code> style and inherits all styling options from the default border style. Visually it displays table <code>head</code> and <code>body</code> as 2 separated table areas. To use this border add <code>.border-dotted</code> to the table head row.`
export const DashedBorder = "Dashed Border"
export const DashedBorderMessage= `Example of a <code>dashed</code> border inside table head. This border has <code>3px</code> width, <code>dashed</code> style and inherits all styling options from the default border style. Visually it displays table <code>head</code> and <code>body</code> as 2 separated table areas. To use this border add <code>.border-dashed</code> to the table head row.`
export const DefultStyling = "Defult Styling"
export const DefultStylingMessage = `use class <code>table table-styling</code>   inside table element`
export const TableheadoptionsWithPrimaryBackground = "Table head options With Primary Background"
export const TableheadoptionsWithPrimaryBackgroundMessage = `Use background classes<code>.bg-*</code>and <code>table-primary</code>,<code>table-secondary</code>,<code>table-success</code>,<code>table-danger</code> ,<code>table-info</code>,<code>table-warning</code>  to make custom <code>thead</code> background. You can also use Stack Admin color palette classes for background.`
export const CustomTableColorwithHoverandStripped = "Custom Table Color with Hover and Stripped"
export const CustomTableColorwithHoverandStrippedMessage  =`Use class<code>table-hover, table-striped table-*</code><code>table-info</code>,<code>table-success</code>,<code>table-success</code>,<code>table-info</code>,<code>table-danger</code>,<code>table-primary</code>,<code>table-secondary</code>,<code>table-light</code>,<code>table-active</code> inside table element.`
export const DataTables = "Data Tables"
export const Status = "Status"
export const TableComponents = "Table Components"
export const UIComponents ="UI Components"
export const DefaultButtonsMessage="Sveltestrap includes six predefined button styles, each serving its own semantic purpose."
export const RoundButtonsMessage=`Use <code>.btn-pill</code> class to button for Round Buttons.`
export const RoundButtons = "Round Buttons"
export const Buttondropdowns = "Button dropdowns"
export const ButtondropdownsMessage = `Use <code>.dropdown-toggle</code> class to button for Dropdown-toggle.`
export const BasicButtongroup = "Basic Button group"
export const BasicButtongroupMessage = "Use <code>btn-group</code> class to button for <code>div</code>."
export const ButtonswithIcon = "Buttons with Icon"
export const ButtonswithIconMessage="Bootstrap includes six predefined button styles, each serving its own semantic purpose."
export const IconButton = "Icon Button"
export const SimpleIconButton = "Simple Icon Button"
export const LoadingButtons  ="Loading Buttons"
export const ExpandUP = "Expand UP"
export const ExpandAnimationButtons = "Expand Animation Buttons"
export const BasicAlert ="Basic Alert"
export const BasicAlertMessage=`Alerts are available for any length of text, as well as an optional dismiss button. Add <code> alert alert-primary</code>,<code> alert alert-secondary</code>,<code> alert alert-success</code>,<code> alert alert-info</code> classes for alert with all theme colors.`
export const AlertswithLinks= "Alerts with Links"
export const AlertswithLinksMessage=`lerts are available for any length of text, as well as an optional dismiss button. Add <code> alert alert-primary</code>,<code> alert alert-secondary</code>,<code> alert alert-success</code>,<code> alert alert-info</code> classes for alert with all theme colors.`
export const DismissibleAlerts = "Dismissible Alerts"
export const DismissibleAlertsMessage=`Add a dismiss button and the<code> alert alert-dismissable</code>class, which adds extra padding to the right of the alert and positions the<code>close</code>a link On the dismiss button, add the data-bs-dismiss="alert" attribute, which triggers the JavaScript functionality. Be sure to use the<code>a</code>element with it for proper behavior across all devices. To animate alerts when dismissing them, be sure to add the .fade and .in classes.`
export const Alertswithicons = "Alerts with icons"
export const AlertswithiconsMessage=`Add a dismiss button and the<code> alert alert-dismissable</code>class, which adds extra padding to the right of the alert and positions the<code>close</code>a link On the dismiss button, add the data-bs-dismiss="alert" attribute, which triggers the JavaScript functionality. Be sure to use the<code>a</code>element with it for proper behavior across all devices. To animate alerts when dismissing them, be sure to add the .fade and .in classes.`
export const DefaultProgress = "Default Progress"
export const DefaultProgressMessage=`Uses a progress bar with class<code>progress-bar</code> and background color<code>bg-primary, bg-secondary</code>also change`
export const StripedProgress ="Striped Progress"
export const StripedProgressMessage=`Uses a gradient to create a striped effect class.<code>progress-bar-striped</code>`
export const ProgressSizes = "Progress Sizes"
export const ProgressSizesMessage=`Different sized progress. For Default progress, class need<code>lg-progress-bar</code>on div.`
export const BasicCheckbox = "Basic Checkbox"
export const DefaultCheckboxSquar ="Default Checkbox Squar"
export const DefaultCheckboxSquarMesaage=`Wrap with use <code>.m-squar</code> checkbox.`
export const BasicSkinCheck ="Basic Skin Check"
export const BasicSkinCheckMessage=`Wrap with use<code>checkbox-dark</code>for this style of checkbox.`
export const FlatSkinCheck ="Flat Skin Check"
export const FlatSkinCheckMessage=`Wrap with use<code>checkbox-solid-*</code>,<code>primary, secondary, success, info, warning, danger</code>for this style of checkbox.`
export const DisableCheck= "Disable Check"
export const DisableCheckMessage=`Wrap with use<code>disabled</code>,<code>primary, secondary, success, info, warning, danger</code>for this style of checkbox disable.`
export const InlineCheckbox= "Inline  Checkbox"
export const InlineCheckboxMessage=`Wrap with use<code>disabled</code>,<code>primary, secondary, success, info, warning, danger</code>for this style of checkbox disable.`
export const SWITCH = "SWITCH"
export const DefaultSwitchMessage=`Use class <code>switch</code> for label.`
export const DisableSwitch = "Disable Switch"
export const DisableSwitchMessage=`this Disable Switch <code>disabled</code>`
export const SwitchColorMessage=`Use  class <code>bg-*</code><code>Primary , Secondary , Success , Info , Warning , Danger</code>in span with icon show switch <code>icon-state</code>on div.`
export const SwitchOutlineMessage=`Use  class <code>switch-outline</code>on div.`
export const TooltipTriggers = "Tooltip Triggers"
export const HoverMessage=`Use data-bs-toggle="tooltip" for hover trigger. This is a default trigger`
export const outlinebutton ="outline button"
export const outlinebuttonMessage=`Use  <code>btn btn-outline-info</code> for outline trigger. and button bold Border use class<code>btn btn-outline-dark-2x</code>`
export const LinktooltipMessage=`Use  <code>a href="javascript:void(0)"</code> for link trigger. This is a link trigger`
export const BasicPills = "Basic Pills"
export const BasicPillsMessage=`Use the <code>.badge</code> class, followed by. with badge color use class <code>.badge-*</code><code>primary , secondary , success , info, warning, danger, light</code>  class within element to create default pill.`
export const LabelWithIcon = "Label With Icon"
export const PrimaryLabel = "Primary Label"
export const PrimaryLabelMessage=`Use the <code>label-square</code> class with <code>div</code>`
export const DefaultInputtext = "Default Input text"
export const InputHoverColor= "Input Hover Color"
export const InputHoverColorMessage=`Use for basic input color add class<code>input-air-*</code><code>primary, secondary, success, info</code>.on input`
export const SingleSelect = "Single Select"
export const SingleSelectMessage="Use for basic select control."
export const DisabledSelectMode = "Disabled Select Mode"
export const DisabledSelectModeMessage=`Use for disabled select control add <code>disabled</code>.`
export const LargeSelectMode = "Large Select Mode"
export const LargeSelectModeMessage=`Use for large and small select control add class<code>form-control-*</code><code>lg, sm</code>.`
export const Examplemultipleselect ="Example multiple select"
export const ExamplemultipleselectMessage=`Use for multi select control add code <code>multiple</code>on select.`
export const RadioButtons = "Radio Buttons"
export const BasicRadioButtons = "Basic Radio Buttons"
export const DefaultRadio = "Default Radio"
export const DefaultRadioMessage=`Wrap with use <code>.radio-*</code> and color <code>.radio-*</code><code>primary , secondary , success , info</code> on Radio.`
export const CheckedRadio = "Checked Radio"
export const CheckedRadioMessage=`Wrap with use<code>checkbox-dark</code>for this style of checkbox.`

//  Forms
export const ValidationForms = "Validation Forms"
export const CustomStyles = "Custom Styles"
export const SubmitForm = "Submit Form"
export const Browserdefaults ="Browser defaults"
export const TooltipValidation = "Tooltip Validation"
export const BasicFormInput = "Basic Form Input"
export const BasicHTMLInputForm = "Basic HTML Input Form"
export const EdgeInputStyle= "Edge Input Style"
export const FlatInputStyle = "Flat Input Style"
export const RaiseInputStyle = "Raise Input Style"
export const InputSizing= "Input Sizing"
export const CustomInput = "Custom Input"
export const FirstName= "First Name"
export const LastName= "Last Name"
export const Address= "Address"
export const City= "City"
export const PostalCode= "Postal Code"
export const AboutMe= "About Me"
export const UpdateProfile= "Update Profile"
export const Website= "Website"
export const EditProfile = "Edit Profile"
export const MyProfile= "My Profile"
export const Save= "Save"
export const UserCards =  "User Cards"
export const TotalPost = "Total Post"

// Bookmark
export const Apps = "Apps"
export const Bookmarks= "Bookmarks"
export const NewBookmark= "New Bookmark"
export const Bookmarkfilter= "Bookmark filter"
export const Tags= "Tags"
export const NoBookmarksFound= "No Bookmarks Found."
export const Notification= "Notification"
export const Newsletter= "Newsletter"
export const Business= "Business"
export const Holidays = "Holidays"
export const Important="Important"
export const Orgenization= "Orgenization"
export const Favourites= "Favourites"
export const Sharedwithme= "Shared with me"
export const Createdbyme= "Created by me"
export const Mybookmark= "My bookmark"
export const AddBookmark= "Add Bookmark"
export const CreateTag= "Create Tag"
export const TagName= "Tag Name"
export const Tagcolor= "Tag color"
export const WebUrl= "Web Url"
export const EditBookmark= "Edit Bookmark"
export const Titles= "Title"
export const Descriptions= "Description"
export const Group= "Group"
export const MyBookmarks= "My Bookmarks"
export const Collection= "Collection"
export const Fs= "fs"
export const Views = "Views"

// Todo
export const ToDoList= "To Do List"
export const ToDofilter= "To Do filter"
export const ToDo= "To-Do"
export const Addnewtask= "Add new task"
export const AddTask="Add Task"
export const Markallasfinished= "Mark all as finished"
export const MarkallasIncomplete= "Mark all as Incomplete"

// search result
export const SearchResult= "Search Result"
export const SearchPages= "Search Pages"
export const Search= "Search"
export const SearchresultforPixelstrap= "Search result for 'Pixelstrap'"
export const details2= "Accusamus et iusto odio dignissimos ducimus qui blanditiis."

//Social App
export const SocialApp= "Social App"
export const MyPage= "My Page"
export const MutualFriends= 
"Mutual Friends"
export const ActivityFeed= "Activity Feed"
export const ProfileIntro="Profile Intro"
export const Followings= "Followings"
export const LatestPhotos= "Latest Photos"
export const Friends= "Friends"
export const Generalmanager= "general manager"
export const MoreCommnets= "More Commnets"
export const PepoleYouMayKnow= "Pepole You May Know"
export const AddFriend= "Add Friend"
export const HobbiesandInterests = "Hobbies and Interests"
export const EducationandEmployement= "Education and Employement"
export const ViewedYourProfile= "Viewed Your Profile"
export const ActivityLog= "Activity Log"
export const State= "State"
export const Zip= "Zip"
export const BasicInput= "Basic Input"
export const FormValiadtion= "Form Valiadtion"
export const SimpleInput= "SimpleInput"
export const Placeholder= "Placeholder"
export const Password= "Password"
export const Number= "Number"
export const Telephone= "Telephone"
export const URL= "URL"
export const DateAndTime= "Date And Time"
export const Date= "Date"
export const Week= "Week"
export const Time= "Time"
export const ColorPicker= "Color Picker"
export const MaximumLength= "Maximum Length"
export const StaticText= "Static Text"
export const Textarea= "Textarea"
export const ExampleSelect= "Example Select"
export const ExampleMultipleSelect= "Example Multiple Select"
export const ExampleTextarea= "Example Textarea"
export const LargeInput= "Large Input"
export const DefaultInput = "Default Input"
export const SmallInput= "Small Input"
export const LargeSelect= "Large Select"
export const DefaultSelect= "Default Select"
export const SmallSelect = "Small Select"
export const UploadFile= "UploadFile"
export const CustomSelect= "CustomSelect"
export const CustomStylesMessage=`For custom Bootstrap form validation messages, you’ll need to add
the <code class="text-danger">novalidate</code> boolean attribute to
your <code class="text-danger">&lt;form&gt;</code>. This disables
the browser default feedback tooltips, but still provides access to
the form validation APIs in JavaScript. Try to submit the form
below; our JavaScript will intercept the submit button and relay
feedback to you.</span
><span
>When attempting to submit, you’ll see the <code class="text-danger"
  >:invalid
</code>
and <code class="text-danger">:valid </code> styles applied to your form
controls.`
export const BrowserdefaultsMessage = `"Not interested in custom validation feedback messages or writing
JavaScript to change form behaviors? All good, you can use the browser
defaults. Try submitting the form below. Depending on your browser and
OS, you’ll see a slightly different style of feedback."
</span>
<span>
"While these feedback styles cannot be styled with CSS, you can still
customize the feedback text through JavaScript."`
export const TooltipValidationMessage  = `If your form layout allows it, you can swap the <code
class="text-danger">.{valid | invalid}-feedback</code
>
classes for
<code class="text-danger">.{valid | invalid}-tooltip</code>
classes to display validation feedback in a styled tooltip. Be sure to
have a parent with
<code class="text-danger">position: relative</code> on it for tooltip
positioning. In the example below, our column classes have this already,
but your project may require an alternative setup.`
export const Supportedelements= "Supported elements"
export const SupportedelementsMessage=`Not interested in custom validation feedback messages or writing
JavaScript to change form behaviors? All good, you can use the
browser defaults. Try submitting the form below. Depending on your
browser and OS, you’ll see a slightly different style of feedback.</span
><span
>While these feedback styles cannot be styled with CSS, you can
still customize the feedback text through JavaScript.`
export const BaseInputs = "Base Inputs"
export const Cancel = "Cancel"
export const Submit = "Submit"
export const SolidInputStyle = "Solid Input Style"
export const CheckboxAndRadio = "Checkbox & Radio"
export const CustomRadio= "Custom Radio"
export const Radiostates = "Radio states"
export const Inlinecheckbox = "Inline checkbox"
export const Option = "Option"
export const Customcheckbox = "Custom checkbox"
export const Checkboxstates = "Checkbox states"
export const Successstate = "Success state"
export const Brandstate = "Brand state"
export const primarystate ="primary state"
export const Animatedradiobuttons = "Animated radio buttons"
export const Animatedcheckboxbuttons = "Animated checkbox buttons"
export const Squarecheckbox = "Square checkbox"
export const Solidcheckbox ="Solid checkbox"
export const InputGroups ="Input Groups"
export const BasicInputgroups = "Basic Input groups"
export const LeftAddon = "Left Addon"
export const RightAddon = "Right Addon"
export const JointAddon ="Joint Addon"
export const LeftRightAddon = "Left & Right Addon"
export const Solidstyle ="Solid style"
export const Squarestyle = "Square style"
export const Raisestyle = "Raise style"
export const Flatstyle = "Flat style"
export const MegaOptions ="Mega Options"
export const Checked = "Checked"

// Mega options
export const Megaoptions = "Mega options"
export const DefaultMessage = "This option is show buydefault you don't need to add any extra class"
export const NoBorder= "No Border"
export const  NoBorderMessage= 
"By adding .plain-style class to .mega-inline You can archive this style"
export const SolidBorderStyle= "Solid Border Style"
export const SolidMeassag = "By adding .border-style class to .mega-inline You can archive this style"
export const OfferstyleBorder= "Offer style Border"
export const OffsetMessage = "By adding .offer-style class to .mega-inline You can archive this style"
export const InlineStyle= "Inline Style"
export const InlineMessage = `For Create inline megaoption add <code>.mega-inline</code> class in form tag`
export const VerticalStyle= "Vertical Style"
export const VerticalMessage = `For Create inline megaoption add <code>.mega-vertical</code> class in form tag`
export const DeliveryOption= "Delivery Option"
export const BuyingOption= "Buying Option"
export const startrating= "start rating"
export const HorizontalStyle= "Horizontal Style"
export const HorizontalMessage =`For Create inline megaoption add <code>.mega-horizontal</code> class in form tag`
export const DefaultForms= "Default Forms"


// Form Layout
export const FormLayout= "Form Layout"
export const DefaultFormLayout = "Default Form Layout"
export const FormMessag = `Using the <a href="#">card</a> component, you can extend the default collapse behavior to create an accordion.`
export const Formtext = "We'll never share your email with anyone else."
export const Remembermyreference= "Remember my preference"
export const HorizontalFormLayout= "Horizontal Form Layout"
export const HorizontalMessag = `Using the <a href="#">card</a> component, you can extend the default collapse behavior to create an accordion.`
export const Radios= "Radios"
export const Checkboxes= "Checkboxes"
export const InlineForm= "Inline Form"
export const  InlineMessag=`Use <code>.form-inline</code> class in the form to style with inline fields.`
export const InlineFormwithLabel= "Inline Form with Label"
export const Login="Login"
export const InlineFormwithoutLabel= "Inline Form without Label"
export const Megaform= "Mega form"
export const AccountInformation= "Account Information"
export const ContactNumber= "Contact Number"
export const CompanyInformation= "Company Information"
export const CompanyName= "Company Name"
export const BillingInformation= "Billing Information"
export const FormWizard = "Form Wizard"
export const FormWizard2 = "Step Form Wizard"
export const FormWizard3= "Form Wizard With Icon"
export const SimpleFormWizard= "Simple Form Wizard"
export const PleaseMake = "Please Make sure fill all the filed before click on next button"
export const ConfirmPassword= "Confirm Password"
export const ContactNo= "Contact No."
export const Birthday= "Birthday"
export const Age= "Age"
export const HavePassport= "Have Passport"
export const FormWizardAndValidation= "Form Wizard And Validation"
export const ValidationStepFormWizard= "Validation Step Form Wizard"
export const Birthdate= "Birthdate"
export const Finish= "Finish"

// Form Widgets
export const FormWidgets= "Form Widgets"
export const DatePickers= "Date Picker"
export const Selectingmultipledates= "Selecting multiple dates"
export const Monthselection= "Month selection"
export const Minimumandmaximumdates= "Minimum and maximum dates"
export const Rangeofdates= "Range of dates"
export const Disabledaysofweek= "Disable days of week"
export const Orientation="Orientation"
export const PermanentlyvisibleDatepicker= "Permanently visible Datepicker"
export const TimePickers= "Time Picker"
export const Alignthearrowtotopautoclose= "Align the arrow to top, auto close"
export const Setoptions  = "Set options in javascript, instead of data-* "
export const Setdefault = "Set default value, input without addon"
export const DateTimePicker= "Date Time Picker"
export const MinimumSetup= "Minimum Setup"
export const UsingLocales= "Using Locales"
export const TimeOnly= "Time Only"
export const DateOnly= "Date Only"
export const NoIconinputfieldonly= "No Icon (input field only)"
export const EnabledDisabledDates= "Enabled/Disabled Dates"
export const ViewMode= "View Mode"
export const DisabledDaysoftheWeek= "Disabled Days of the Week"
export const Clipboard= "Clipboard"
export const ClipboardOnTextInput= "Clipboard On Text Input"
export const Cutcopyfromtextinput= "Cut/copy from text input"
export const Copy= "Copy"
export const Cut= "Cut"
export const ClipboardOnTextarea= "Clipboard On Textarea"
export const Cutcopyfromtextarea= "Cut/copy from textarea"
export const para = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has"
export const ClipboardOnParagraph= "Clipboard On Paragraph"
export const CopyfromParagraph= "Copy from Paragraph"
export const Paragraph ="Lorem ipsum dolor sit amet, consectetur adipiscing elit,sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
export const CopyPortionFromParagraph= "Copy Portion From Paragraph"
export const Copyhighlightedtext= "Copy highlighted text"
export const Copypara =", consectetur adipiscing elit,sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
export const Loremipsum= "Lorem ipsum"
export const dolorsitamet= "dolor sit amet"
export const Typeaheads= "Typeahead"
export const RTLSupport= "RTL Support"
export const DatasetshowsinRightSide= "Dataset shows in Right Side."
export const Switch= "Switch"
export const BasicSwitch= "Basic Switch"
export const DefaultSwitch= "Default Switch"
export const UnheckedSwitch= "Unhecked Switch"
export const UnheckedWithIcon= "Unhecked With Icon"
export const DisabledState= "Disabled State"
export const DisabledWithIcon= "Disabled With Icon"
export const SwitchOutline= "Switch Outline"
export const SwitchColor= "Switch Color"
export const SwitchuncheckedOutline= "Switch unchecked Outline"
export const SwitchSizing= "Switch Sizing"
export const SwitchWithicon= "Switch With icon"
export const SwitchWithcolor= "Switch With color"
export const Select2= "Select2"
export const Select= "Select-2"
export const OutlineColorVariant= "Outline Color Variant"
export const FullColoredVariant= "Full Colored Variant"
export const DefaultPlaceholder= "Default Placeholder"
export const RTLsupport= "RTL support"
export const DisabledResults= "Disabled Results"
export const EnableDisable= "Enable-Disable"
export const Disable= "Disable"
export const Enable= "Enable"
export const First= "First"
export const Third= "Third"
export const Seconddisabled= "Second(disabled)"
export const Select2singleselect = "Select2 single select"
export const Select2multiselect = "Select2 multi select"
export const HidingTheSearchBox = "Hiding The Search Box"
export const LimitingTheNumberOfSelections = "Limiting The Number Of Selections"
export const Touchspin= "Touchspin"
export const DefaultTouchspin= "Default Touchspin"
export const DefaultTouchspinMessage=`Add <code>.touchspin</code> class to input to add touchspin input group.`
// ApexChart
export const ApexChart= "Apex Chart"
export const Charts = "Charts"
export const BasicAreaChart = "Basic Area Chart"
export const AreaSpalineChart  ="Area Spaline Chart"
export const Barchart = "Bar chart"
export const ColumnChart = "Column Chart"
export const BubbleChart = "3d Bubble Chart"
export const CandlestickChart = "Candlestick Chart"
export const SteplineChart ="Stepline Chart"
export const PieChart = "Pie Chart"
export const DonutChart = "Donut Chart"
export const RadarChart = "Radar Chart"
export const RadialBarChart = "Radial Bar Chart"
export const MixedChart ="Mixed Chart"

// Sparkline Chart
export const SparklineChart = "Sparkline Chart"
export const MouseSpeedChart = "Mouse Speed Chart"

// ChartJS Chart
export const ChartJSChart = "ChartJS Chart"
export const BarChart = "Bar Chart"
export const LineGraph = "Line Graph"
export const LineChart = "Line Chart"
export const Line2Chart = "Line2 Chart"
export const DoughnutChart = "Doughnut Chart"
export const PolarChart = "Polar Chart"
export const RadarGraph = "Radar Graph"
